<template>
	<div>
		<div v-show="Receivable">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">甲方欠款系列汇总表</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:10px"></div>
					<div style="display:flex;margin-top:20px">
						<span>体系名称 </span>
						<el-select v-model="condition.series" style="margin-left:20px;margin-top:-10px"
							:placeholder="postPlaceholder" clearable>
							<el-option v-for="item in seriesList" :key="item.id" :label="item.data" :value="item.id">
							</el-option>
						</el-select>
						
						<div style="margin:-10px 0 0 20px">
							<el-button type="goon" @click="Find">查询</el-button>
							<div style="display:inline-block;margin-left:190px">
								<download-excel class="export-excel-wrapper" :fields="download_excel" title="调岗人员清单"
									name="调岗人员清单.xls" :fetch="ExportForm" style="margin-left:-180px;top:100px">
									<el-button type="goon"
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
										导出</el-button>
								</download-excel>
							</div>
						</div>
					</div>
				</div>

				<!-- 表格 -->
				<div style="margin:2% 3% 0 3%;">
					<div v-for="(item,index) in tableData">
						<el-table :data="item.sectorList" :header-cell-style="{background:'#d3eae2',color:'#000000'}"
							:span-method="objectSpanMethod" border @selection-change="handleSelectionChange"
							style="width: 100%;margin-top:10px" @cell-mouse-leave="cellMouseLeave" :summary-method="getSummaries"
							@cell-mouse-enter="cellMouseEnter" height="320" :cell-class-name="tableRowClassName">
							<el-table-column prop="sectorName" align="center" label=""></el-table-column>
							<el-table-column prop="organizeName" align="center" :label="item.seriesName"></el-table-column>
							<el-table-column prop="amount" align="center" label=""></el-table-column>
							<el-table-column prop="actualPeriod" align="center" label="实际账期"></el-table-column>
							<el-table-column prop="agreePeriod" align="center" label="合同约定账期"></el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			return {
				total: 0,
				seriesList:[],
				tableData: [],
				orderIndexArr: [],
				hoverOrderArr: [],
				ruleForm: {

				},

				download_excel: {},
				// 权限
				Receivable: true,
				showedit: false,
				editList: {},
				ids: [],
				//条件
				condition: {
					series: '',
				},
				project_id: [],

				//回显查询岗位
				project_ide: '',
			};
		},
		methods: {
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				});
			},
			// 弹窗
			// handleClose() {
			//     this.dialogVisible = false
			// },
			Return() {
				this.showadd = false;
				this.Receivable = true;
				this.trash();
				this.Find();
			},
			//查询
			async Find() {
				var data = await this.$globals.AxiosPost('AccountsInvoiceRegistration/getDetSummary', this.condition);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data;
						this.total = data.total;
						this.getOrderNumber()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			getOrderNumber() {
				const orderObj = {};
				this.tableData.forEach((item, index) => {
					item.rowIndex = index;
					if (orderObj[item.sectorName]) {
						orderObj[item.sectorName].push(index);
					} else {
						orderObj[item.sectorName] = [];
						orderObj[item.sectorName].push(index);
					}
				});
				// 将数组长度大于1的值 存储到this.orderIndexArr（也就是需要合并的项）
				Object.keys(orderObj).forEach((key) => {
					if (orderObj[key].length > 1) {
						this.orderIndexArr.push(orderObj[key]);
					}
				});
			},
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
			
					for (let i = 0; i < this.orderIndexArr.length; i += 1) {
						let element = this.orderIndexArr[i];
						for (let j = 0; j < element.length; j += 1) {
							let item = element[j];
							if (rowIndex === item) {
								if (j === 0) {
									return {
										rowspan: element.length,
										colspan: 1,
									};
								}
								if (j !== 0) {
									return {
										rowspan: 0,
										colspan: 0,
									};
								}
							}
						}
					}
				}
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				let arr = this.hoverOrderArr;
				for (let i = 0; i < arr.length; i += 1) {
					if (rowIndex === arr[i]) {
						return 'hovered-row';
					}
				}
			},
			cellMouseEnter(row, column, cell, event) {
				this.rowIndex = row.rowIndex;
				this.hoverOrderArr = [];
				this.orderIndexArr.forEach((element) => {
					if (element.indexOf(this.rowIndex) >= 0) {
						this.hoverOrderArr = element;
					}
				});
			},
			cellMouseLeave(row, column, cell, event) {
				this.rowIndex = '-1';
				this.hoverOrderArr = [];
			},

			// 操作删除
			async Del(e) {
				var ids;
				if (e === null || e === "" || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning("请先选择操作数据！");
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}

				var url = "StaffTransfer/del";
				var record = {
					ids: ids,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.trash();
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			//分页
			handleCurrentChange(val) {
				this.condition.page_num = val;
				this.Find();
			},
		},
		async created() {
			var seriesList = await this.$globals.AxiosPost("dictionaries/selectFind", {
			    data_grouping: "business_series"
			});
			this.seriesList = seriesList.data;
			this.Find();
		},
	};
</script>


<style scoped>


	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}

	.el-button--pic {
		color: #006E4B;
		background-color: #fff;
		border-color: #006E4B;
		font-size: 10px;
		height: 30px;
		width: 70px;
		padding: 10px;
	}

	.el-button--pic:focus,
	.el-button--pic:hover {
		background: #fff;
		border-color: #05573d;
		color: #006E4B;
	}
</style>



// WEBPACK FOOTER //
// DetailsparB.vue?83ec9810